module.exports = __webpack_public_path__ + "static/media/gal636352.7bc96e14.png";